import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it a physical product or digital?',
  a: 'It is a 100% digital product delivered as high-resolution PDF files, optimized for viewing on iPad, tablet, laptop, or smartphone. You receive instant access immediately after your purchase. No waiting, no shipping.'
}, {
  q: 'Do I need advanced coaching experience to use it?',
  a: 'No.  FUNCTIONAL PRO™ is designed for functional coaches, personal trainers, group fitness instructors, and studio owners at all levels of experience. Whether you are 2 years in or 15 years in, you will find tools you can use immediately with your clients.'
}, {
  q: 'Does it work for both group training and one-on-one sessions?',
  a: 'Absolutely. Every module includes specific adaptations for group training, semi-private sessions, and one-on-one coaching. The Workout Builder System and the 100 Ready-to-Use Workouts are structured to work in both formats without modification.'
}, {
  q: 'How fast can I start using this with my clients?',
  a: "Immediately. You get instant access to all 6 modules and bonuses the moment you purchase. You can open the 100 Ready-to-Use Workouts, pick a session that matches your client', s, level, and coach it in your very next session. No setup, no learning curve — just open and go."
}, {
  q: 'Do I get the bonuses immediately?',
  a: 'Yes. All 5 professional bonuses are included with your purchase and delivered instantly along with the main system. You get immediate access to the Session Scriptbook, 12-Week Challenge Calendar, Assessment Kit, Equipment Circuit Playbook, and Progress Dashboard Pack.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'One-time payment only. You pay $27 once and get lifetime access to the entire FUNCTIONAL PRO™ system, all 6 modules, all 5 bonuses, and any future updates we add. No recurring charges, no hidden fees, no subscriptions.'
}, {
  q: 'Can I print the PDFs?',
  a: 'Yes! All PDFs are printer-friendly. You can print individual workouts, specific modules, or the entire system if you prefer working from paper. Many coaches print their favorite sessions and keep them in a binder at the gym.'
}, {
  q: 'What equipment is needed for the workouts?',
  a: 'The system includes workouts for all equipment levels — bodyweight only, dumbbells, kettlebells, resistance bands, TRX, medicine balls, and more. The Equipment Circuit Playbook bonus gives you 25 ready-to-use templates organized by equipment type, so you can work with whatever you have available.'
}, {
  q: 'Is it suitable for online/remote coaching?',
  a: 'Absolutely. The workouts, programs, and templates work perfectly for in-person and online coaching. The Client Transformation Programs module includes communication tools and progress tracking systems specifically designed for remote coaching scenarios.'
}, {
  q: "How do I get the refund if I', m, not, satisfied.",
  a: 'Simply email us within 7 days of your purchase and we\'ll process a full refund immediately. No questions asked no hoops to jump through. We stand behind the system 100% and want you to feel completely confident in your investment.\"'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <div className="text-center mb-5" data-id="element-53">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-1" data-id="element-54">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <p className="text-base text-brand-graphite/70" data-id="element-55">
            Answering your questions
          </p>
        </div>

        <div className="space-y-3" data-id="element-56">
          {faqs.map((faq, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 rounded-lg overflow-hidden" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-cream/50 transition-colors gap-4" data-id="element-58">
                <span className="font-bold text-brand-graphite text-base" data-id="element-59">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-petrol transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>

              {openIndex === i && <div className="px-5 pb-4 pt-0 text-brand-graphite/80 leading-relaxed" data-id="element-61">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}